// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginLoadWishListLines,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

const XngDispatchBeginLoadWishListLines: typeof DispatchBeginLoadWishListLines = props => {
    if (!(props.parameter as any).forceLoad) {
        DispatchBeginLoadWishListLines(props);
        return;
    }
    props.dataViewParameter = props.getState().pages.myListDetails.loadWishListLinesParameter;
    props.dispatch({
        type: "Data/WishListLines/BeginLoadWishListLines",
        parameter: props.dataViewParameter,
    });
};
replaceInChain(chain, DispatchBeginLoadWishListLines, XngDispatchBeginLoadWishListLines);
